import { render, staticRenderFns } from "./exchangeCard.vue?vue&type=template&id=15753b9a&scoped=true&"
import script from "./exchangeCard.vue?vue&type=script&lang=js&"
export * from "./exchangeCard.vue?vue&type=script&lang=js&"
import style0 from "./exchangeCard.vue?vue&type=style&index=0&id=15753b9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15753b9a",
  null
  
)

export default component.exports